<template>
  <v-dialog
    v-if="levelDetail"
    v-model="openLevelDialog"
    
    max-width="500px"
  >
    <v-card :loading="levelDialogLoading">
      <v-card-title>
        <span class="headline">
          <v-icon color="#4dbac0" size="30" class="pb-1">calendar_view_day</v-icon>
          {{ levelDetail.level.name }}: {{levelDetail.trades.length}} trades
        </span>
        <v-btn style="position: absolute; right: 20px" icon dark @click="closeLevel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class>
        <v-row class="px-4">
          <v-col cols="12" class="mb-4">
            <span class="roboto-title">Zone</span>
            mid: {{levelDetail.level.price}} high: {{levelDetail.level.high}} low: {{levelDetail.level.low}}
          </v-col>

          <v-col cols="12">
            <div class="roboto-title">Description</div>
            {{levelDetail.level.description}}
          </v-col>
          <v-col cols="12" class="mt-4">
            <div class="roboto-title mb-2">Media</div>
            <vue-picture-swipe :items="levelDetail.level._images" small></vue-picture-swipe>
          </v-col>
        </v-row>
        <v-row class>
          <v-col cols="6">
            <MiniGauge :data="levelStats.successRate" :hideSettings="true" />
          </v-col>
          <v-col cols="6">
            <MiniEquity source="direct" :data="levelStats.equity" :hideSettings="true" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-col style="margin-top: -30px" cols="12" sm="12" md="12"></v-col>
    </v-card>
  </v-dialog>
</template>

<script>
//var moment = require("moment-timezone");
import axios from "axios";
//import { mapGetters } from "vuex";
import MiniGauge from "@/components/minicharts_v2/miniGauge.vue";
import MiniEquity from "@/components/minicharts_v2/miniEquity.vue";
import VuePictureSwipe from "vue-picture-swipe";

export default {
  components: { MiniGauge, MiniEquity, VuePictureSwipe },
  props: ["id"],
  data() {
    return {
      levelStats: {
        successRate: 0,
        weekDays: [0, 0, 0, 0, 0, 0, 0],
        lastSeven: [],
        equity: [0]
      },
      levelDialogLoading: false,
      openLevelDialog: false
    };
  },
  methods: {
    closeLevel() {
      this.openLevelDialog = false;
      this.levelDetail = null;
      this.$emit("clearDetail");
    }
  },
  asyncComputed: {
    levelDetail: {
      get() {
        if (this.id) {
          this.levelDialogLoading = true;
          this.openLevelDialog = true;
          return new Promise((resolve, reject) => {
            axios
              .post("https://tradeinpool.com:3001/api/request/levels/", {
                id: this.id
              })
              .then(response => {
                this.levelStats = this.$statistics(response.data.trades)
                this.levelDialogLoading = false;
                this.openLevelDialog = true;
                resolve(response.data);
              })
              .catch(err => {
                reject(err);
              });
          });
        }
      },
      default: {},
      watch: ["id"]
    }
  }
};
</script>

<style>
</style>